import { render, staticRenderFns } from "./UserNoticeTemplate.vue?vue&type=template&id=dbab8394&scoped=true&"
import script from "./UserNoticeTemplate.vue?vue&type=script&lang=js&"
export * from "./UserNoticeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./UserNoticeTemplate.vue?vue&type=style&index=0&id=dbab8394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbab8394",
  null
  
)

export default component.exports